import { connectCustom } from "@client/lib/misc";

import { type RootContainerProps } from "@client/content/types";
import { type AppState } from "@client/types";
import Component, { type MapsComponentProps } from "./component";
import { makeGoogleKeySelector, makeOptionsSelector } from "./selectors";

const makeMapStateToProps = () => {
  const optionsSelector = makeOptionsSelector();
  const googleKeySelector = makeGoogleKeySelector();

  return (state: AppState, props: RootContainerProps): MapsComponentProps => {
    return {
      googleKey: googleKeySelector(state, props),
      options: optionsSelector(state, props),
      ...props
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
